export default async (code, method) =>
{
  const url = '/Sys/Admin/twofactorauth/doauth';
  const response = await fetch(
    url,
    {
      method: 'POST',
      body: JSON.stringify({ code, method }),
      headers: { 'Content-Type': 'application/json' }
    });

  return response.json();
};